// src/Components/GoogleFireBase/index.js
import React, { useEffect } from "react";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { getMessagingConversationData } from "../../store/MessagingService/action";

const firebaseConfig = {
  apiKey: "AIzaSyAQViY_F5e7yEnRqe3bPxsbLPbYoqG1noc",
  authDomain: "crmitgb.firebaseapp.com",
  projectId: "crmitgb",
  storageBucket: "crmitgb.firebasestorage.app",
  messagingSenderId: "619096691796",
  appId: "1:619096691796:web:1ea5af88e07f43695f89c1",
  measurementId: "G-P40PSYL5H8",
};

const vapidKey =
  "BOi5qOXm3OyeJa5BJpaMoHolCp-NaiR6RuUUDukBTBTuo9WmiigZaghXIQ2VuQUPi6LaOsDp-lziU6F3awNUL6M";

const TOKEN_KEY = "firebase_fcm_token";

function isInReactNativeWebView() {
  return typeof window !== "undefined" && !!window.ReactNativeWebView;
}

function canUseWebPush() {
  return (
    typeof window !== "undefined" &&
    "Notification" in window &&
    typeof navigator !== "undefined" &&
    "serviceWorker" in navigator
  );
}

const GoogleFirebase = ({ setFCMToken }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    // hard stop for mobile / webview
    if (isInReactNativeWebView()) return;
    if (!canUseWebPush()) return;

    let unsubscribed = false;

    const init = async () => {
      try {
        // lazy import firebase so mobile/unsupported envs don't crash at bundle load
        const appMod = await import("firebase/app");
        const { initializeApp, getApps } = appMod;

        const app =
          getApps().length > 0 ? getApps()[0] : initializeApp(firebaseConfig);

        // analytics is optional
        try {
          const analyticsMod = await import("firebase/analytics");
          analyticsMod.getAnalytics(app);
        } catch (_) {
          // ignore
        }

        const messagingMod = await import("firebase/messaging");
        const { isSupported, getMessaging, getToken, onMessage } = messagingMod;

        const supported = await isSupported();
        if (!supported) return;

        const permission = await Notification.requestPermission();
        if (permission !== "granted") return;

        const registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js"
        );

        const messaging = getMessaging(app);

        let token = localStorage.getItem(TOKEN_KEY);
        if (!token) {
          token = await getToken(messaging, {
            vapidKey,
            serviceWorkerRegistration: registration,
          });
          if (token) localStorage.setItem(TOKEN_KEY, token);
        }

        if (!unsubscribed && token && typeof setFCMToken === "function") {
          setFCMToken(token);
        }

        onMessage(messaging, (payload) => {
          if (unsubscribed) return;

          const { MessageBody, MessageTitle } = payload.data || {};
          const { MessagingConversationMessage_Id, MessagingConversation_Id } =
          payload.data || {};

          if (MessagingConversationMessage_Id) {
            dispatch(getMessagingConversationData({ id: MessagingConversationMessage_Id }));
          }

          if (MessageTitle || MessageBody) {
            toast.info(
              ({ closeToast }) => (
                <div>
                  <strong>{MessageTitle || "Notification"}</strong>
                  <p>{MessageBody || "No message body"}</p>
                  {MessagingConversation_Id && (
                    <button
                      onClick={() => {
                        closeToast();
                        history.push(`/messaging-service/${MessagingConversation_Id}/view`);
                      }}
                      style={{
                        marginTop: "0.5rem",
                        padding: "6px 12px",
                        backgroundColor: "#0d6efd",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        cursor: "pointer",
                      }}
                    >
                      Open Conversation
                    </button>
                  )}
                </div>
              ),
              { autoClose: 8000, closeOnClick: false }
            );
          }
        });
      } catch (err) {
        console.error("❌ Error during FCM setup:", err);
      }
    };

    init();

    return () => {
      unsubscribed = true;
    };
  }, [dispatch, history, setFCMToken]);

  return null;
};

export default GoogleFirebase;
